import { useState, useEffect } from 'react';

export default function PageEntrance() {
  const [phase, setPhase] = useState<'in' | 'hold' | 'out' | 'done'>('in');

  useEffect(() => {
    const t1 = setTimeout(() => setPhase('hold'), 60);
    const t2 = setTimeout(() => setPhase('out'), 2400);
    const t3 = setTimeout(() => setPhase('done'), 3500);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, []);

  if (phase === 'done') return null;

  return (
    <div
      className={`fixed inset-0 z-[9999] bg-[#FBF8F3] flex flex-col items-center justify-center transition-opacity duration-600 ${
        phase === 'out' ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
      style={{ transitionDuration: '1100ms' }}
    >
      <div
        className={`flex flex-col items-center gap-5 transition-all duration-500 ${
          phase === 'hold' ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3'
        }`}
      >
        {/* Linha superior */}
        <div
          className="w-px bg-gradient-to-b from-transparent to-[#C4A57B]"
          style={{ animation: 'lineGrow 0.6s ease-out forwards' }}
        />

        {/* Texto central */}
        <div className="flex flex-col items-center gap-2 text-center">
          <p
            className="text-[#C4A57B] text-xs font-medium tracking-[0.35em] uppercase opacity-0"
            style={{ animation: 'fadeIn 0.5s ease-out 0.2s forwards' }}
          >
            Dermatologista
          </p>
          <h2
            className="text-2xl sm:text-3xl font-light text-[#4A3F35] tracking-wide opacity-0"
            style={{ animation: 'fadeInUp 0.6s ease-out 0.3s forwards' }}
          >
            Dra. Laura Folchini
          </h2>
          <p
            className="text-xs text-[#A89580] tracking-widest uppercase opacity-0"
            style={{ animation: 'fadeIn 0.5s ease-out 0.5s forwards' }}
          >
            CRM/SC 21.308
          </p>
        </div>

        {/* Linha inferior */}
        <div
          className="w-px bg-gradient-to-t from-transparent to-[#C4A57B]"
          style={{ animation: 'lineGrow 0.6s ease-out 0.15s forwards' }}
        />

        {/* Barra de loading */}
        <div className="w-28 h-px bg-[#E8DCC8] overflow-hidden rounded-full mt-2">
          <div
            className="h-full bg-[#C4A57B] rounded-full"
            style={{ animation: 'loadBar 0.9s ease-out 0.3s forwards', width: 0 }}
          />
        </div>
      </div>
    </div>
  );
}
